import CryptoJS from "crypto-js";

export const decryptData = (encryptedText) => {
  const key = CryptoJS.enc.Utf8.parse(
    process.env.REACT_APP_SECRETKEY
  );

  const iv = CryptoJS.enc.Utf8.parse(
    process.env.REACT_APP_VECTORKEY
  );

  const decrypted = CryptoJS.AES.decrypt(
    encryptedText,
    key,
    {
      iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    }
  );

  return decrypted.toString(CryptoJS.enc.Utf8);
};
